<style>
  /* required class */
  .my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #2d2d2d;
    color: #ccc;

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    height: 300px;
    line-height: 1.5;
    padding: 5px;
  }

  /* optional class for removing the outline */
  .prism-editor__textarea:focus {
    outline: none;
  }
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" :finishButtonText="$t('Labels.Save')"
                            :nextButtonText="$t('Labels.Next')" :backButtonText="$t('Labels.Back')" @on-complete="requestPassword()">
                          <tab-content :title="$t('Labels.General')" class="mb-5" :before-change="validate1">

                            <!-- tab 1 content -->
                            <form data-vv-scope="step-1">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full mt-5">
                                <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="data.name"/>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mt-5">
                                <label>{{$t('Labels.Organization')}}</label>
                                <v-select :options="organizations" v-model="data.organization_id" :reduce="v => v.id" label="name"/>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mt-5">
                                <label>{{$t('Labels.MacVersion')}}</label>
                                <v-select :options="macVersions" v-model="data.mac_version" :reduce="v => v.value" label="label"/>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mt-5">
                                <label>{{$t('Labels.Region')}}</label>
                                <v-select :options="regions" v-model="data.reg_params_revision" :reduce="v => v.value" label="label"/>
                              </div>
                              <div class="vx-col md:w-1/2 w-full mt-5">
                                <label>{{$t('Labels.Network')}}</label>
                                <v-select :options="networks" v-model="data.network_server_id" :reduce="v => v.id" label="name"/>
                              </div>
                              <div class="vx-col mt-5">
                                <label>{{$t('Labels.Uplink')}}</label>
                                <vs-input-number v-model="data.uplink_interval"/>
                              </div>
                            </div>
                            </form>
                          </tab-content>

                          <!-- tab 2 content -->
                          <tab-content :title="$t('Labels.ClassB')" class="mb-5" >
                            <form data-vv-scope="step-2">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <vs-checkbox v-model="data.supports_class_b">{{$t('Labels.SupportClassB')}}</vs-checkbox>
                              </div>
                              <div class="vx-col">
                                <label>{{$t('Labels.Timeout')}}</label>
                                <vs-input-number v-model="data.class_b_timeout"/>
                              </div>
                            </div>
                            </form>
                          </tab-content>

                          <!-- tab 3 content -->
                          <tab-content :title="$t('Labels.ClassC')" class="mb-5">
                            <form data-vv-scope="step-3">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <vs-checkbox v-model="data.supports_class_c">{{$t('Labels.SupportClassC')}}</vs-checkbox>
                              </div>
                              <div class="vx-col">
                                <label>{{$t('Labels.Timeout')}}</label>
                                <vs-input-number v-model="data.class_c_timeout"/>
                              </div>
                            </div>
                            </form>
                          </tab-content>
                           <!-- tab 4 content -->
                          <tab-content :title="$t('Labels.Codec')" class="mb-5" :before-change="validate4">
                            <form data-vv-scope="step-3">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <label>{{$t('Labels.EncoderScript')}}</label>
                                  <prism-editor class="my-editor mb-4" v-model="data.payload_encoder_script" :highlight="highlighter" line-numbers></prism-editor>
                                  <label class="mt-8" >{{$t('Labels.Param')}}</label>
                                  <prism-editor class="my-editor mb-4" v-model="paramEncoder" :highlight="highlighter" line-numbers></prism-editor>
                                  <div class="vx-row">
                                    <div class="vx-col w-full">
                                      <vs-button @click="testEncoder()" class="bg-primary mb-4 float-right" type="filled">{{$t("Labels.Test")}}</vs-button>
                                    </div>
                                  </div>
                                  <div class="" >{{$t('Labels.Result')}}</div>
                                  <prism-editor class="my-editor" v-model="resultEncoder" :highlight="highlighter" line-numbers readonly></prism-editor>

                                  <vs-checkbox v-model="confirmEncoder" class="mt-4 float-right">{{$t('Labels.Confirm')}}</vs-checkbox>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <label>{{$t('Labels.DecoderScript')}}</label>
                                  <prism-editor class="my-editor mb-4" v-model="data.payload_decoder_script" :highlight="highlighter" line-numbers></prism-editor>
                                  <label class="mt-8" >{{$t('Labels.Param')}}</label>
                                  <prism-editor class="my-editor mb-4" v-model="paramDecoder" :highlight="highlighter" line-numbers></prism-editor>
                                  <div class="vx-row">
                                    <div class="vx-col w-full">
                                      <vs-button @click="testDecoder()" class="bg-primary mb-4 float-right" type="filled">{{$t("Labels.Test")}}</vs-button>
                                    </div>
                                  </div>
                                  <label class="mt-8" >{{$t('Labels.Result')}}</label>
                                  <prism-editor class="my-editor" v-model="resultDecoder" :highlight="highlighter" line-numbers readonly></prism-editor>

                                  <vs-checkbox v-model="confirmDecoder" class="mt-4 float-right">{{$t('Labels.Confirm')}}</vs-checkbox>
                                </div>
                              </div>
                            </form>
                          </tab-content>
                        </form-wizard>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  components: {
    vSelect,
    FormWizard,
    TabContent,
    PrismEditor
  },

  data () {
    return {
      uuid:this.$route.params.uuid, 
      networks: [],
      organizations: [],
      regions:[
        {
          label: this.$t('Labels.SelectOne'),
          value: '0'
        },
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        }
      ],
      macVersions:[
        {
          label: this.$t('Labels.SelectOne'),
          value: '0'
        },
        {
          label: '1.0.0',
          value: '1.0.0'
        },
        {
          label: '1.0.1',
          value: '1.0.1'
        },
        {
          label: '1.0.2',
          value: '1.0.2'
        },
        {
          label: '1.0.3',
          value: '1.0.3'
        },
        {
          label: '1.1.0',
          value: '1.1.0'
        }
      ],
      data:{
        network_server_id: '',
        organization_id: '',
        name: '',
        mac_version: '',
        reg_params_revision: '',
        supports_class_b: true,
        supports_class_c: true,
        class_b_timeout: '',
        class_c_timeout: '',
        payload_codec: 'javascript',
        payload_decoder_script: '',
        payload_encoder_script: '',
        uplink_interval: ''
      },
      paramEncoder:'',
      resultEncoder:'',
      confirmEncoder: false,
      paramDecoder:'',
      resultDecoder:'',
      confirmDecoder: false
    }
  },

  methods: {
    async getCompanies () {
      this.$vs.loading()

      const params = {
        url: 'organizations',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.organizations = response.data.data.result
        this.organizations.unshift({
          id:0,
          name: this.$t('Labels.SelectOne')
        })
      }).finally(() => {
        this.getNetworks()
      })                        
    },
    async getNetworks () {
      this.$vs.loading()
      const params = {
        url: 'network_servers',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.networks = response.data.data.result
      }).finally(() => {
        this.getData()
      })                        
    },
    async getData () {
      const params = {
        url: `device_profiles/${this.uuid}`,
        method: 'GET',
        params: {
          limit: 0
        }
      }
      await request(params).then(response => {
        this.data = response.data.data
        this.$vs.loading.close()
      })
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      const params = {
        url: `device_profiles/${this.uuid}`,
        method: 'PUT',
        params: this.data
      }
      await request(params).then(response => {
        window.location.href = `/profiles/${this.uuid}`
      })  
    },
    highlighter (code) {
      return highlight(code, languages.js)
    },
    validate1 () {
      return (!empty(this.data.name) && this.data.organization_id != 0 && this.data.mac_version != 0 && this.data.reg_params_revision != 0 && this.data.network_server_id != 0)
    },
    validate4 () {
      return (!empty(this.data.payload_decoder_script) && !empty(this.data.payload_encoder_script) && this.confirmDecoder == true && this.confirmEncoder == true)
    },
    testEncoder () {
      const fcEncoder = eval(this.data.payload_encoder_script)
      const param = eval(this.paramEncoder)
      this.resultEncoder = JSON.stringify(fcEncoder(param))
    },
    testDecoder () {
      const fcDecoder = eval(this.data.payload_decoder_script)
      const param = eval(this.paramDecoder)
      this.resultDecoder = JSON.stringify(fcDecoder(param))
    }
  },
  created () {
    this.getCompanies()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.update()
    }
  }
}
</script>
